export default __webpack_public_path__ + "static/media/typemaster.82670d92.jpg";